enum TaskTemplateInputType {
  STRING = 0,
  INTEGER = 1,
  BOOLEAN = 2,
  DOUBLE = 3,
  DATE = 4,
  TIME = 5,
  DATE_TIME = 6,
  SINGLE_CHOICE = 7,
  MULTI_CHOICE = 8,
  RATING = 9,
  LAT_LNG = 10,
  CHECKLIST = 11,
  LABEL = 12
}

export enum TaskTemplateInputTypeLabel {
  STRING = 'Text',
  INTEGER = 'Integer',
  BOOLEAN = 'Yes/No',
  DOUBLE = 'Decimal',
  DATE = 'Date',
  TIME = 'Time',
  DATE_TIME = 'Date Time',
  SINGLE_CHOICE = 'Single Choice',
  MULTI_CHOICE = 'Multi Choice',
  RATING = 'Rating',
  LAT_LNG = 'Location',
  CHECKLIST = 'Checklist',
  LABEL = 'Label'
}

export default TaskTemplateInputType
